import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import {
  CustomInput,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import Select from 'react-select'
import NumberFormat from 'react-number-format'
import TableConfidentialHistory from '../table-confidential-history'

import { status } from '../../constants'

const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

class ConfidentialForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
      showInformation: false,
      information: null,
    }
    this.toggle = this.toggle.bind(this)
    this.handleClickShowInformation = this.handleClickShowInformation.bind(this)
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab })
    }
  }
  handleClickShowInformation(id) {
    const conf = _.get(this.props, 'confidential_group')
    const info = _.find(conf, {
      _id: id,
    })
    this.setState({
      information: info,
      showInformation: true,
    })
  }
  createLevelList() {
    const object = _.get(this.props, 'emp_level_list')
    const temp = [{ label: 'Choose Pay Grade Name', level_code: '' }]
    if (object) {
      object.map((ob) => {
        if (_.get(ob, 'is_active')) {
          temp.push({
            label: `${_.get(ob, 'level_code')} - ${_.get(ob, 'name')}`,
            level_code: _.get(ob, '_id'),
          })
        }
        return ob
      })
    }
    return temp
  }
  createPositionList() {
    const object = _.get(this.props, 'position_list')
    const temp = [{ label: 'Choose Position Name', position_code: '' }]
    if (object) {
      object.map((ob) => {
        if (_.get(ob, 'is_active')) {
          temp.push({
            label: `${_.get(ob, 'position_code')} - ${_.get(ob, 'name')}`,
            position_code: _.get(ob, '_id'),
          })
        }
        return ob
      })
    }
    return temp
  }
  createEmployeeList() {
    const object = _.get(this.props, 'employee_list')
    const temp = [{ label: 'Choose Employee Name', employee_confidential_id: '' }]
    if (object) {
      object.map((ob) => {
        if (!_.get(ob, 'is_init_user') && _.get(ob, 'is_active')) {
          temp.push({
            label: `${_.get(ob, 'emp_code')} - ${_.get(ob, 'first_name')} ${_.get(ob, 'last_name')}`,
            user_id: _.get(ob, '_id'),
            emp_level_id: _.get(ob, 'emp_level_id'),
            position_id: _.get(ob, 'position_id'),
            company_id: _.get(ob, 'company_id'),
            lob_id: _.get(ob, 'lob_id'),
          })
        }
        return ob
      })
    }
    return temp
  }
  checkEmployee(id) {
    const object = _.get(this.props, 'employee_list')
    if (object) {
      for (let i = 0; i < object.length; i++) {
        if (object[i]._id === id) {
          return {
            label: `${_.get(object[i], 'emp_code')} - ${_.get(object[i], 'first_name')} ${_.get(object[i], 'last_name')}`,
            employee_confidential_id: _.get(object[i], '_id'),
            emp_level_id: _.get(object[i], 'emp_level_id'),
            position_id: _.get(object[i], 'position_id'),
            company_id: _.get(object[i], 'company_id'),
            lob_id: _.get(object[i], 'lob_id'),
          }
        }
      }
    }
    return ''
  }
  checkPosition(id) {
    const object = _.get(this.props, 'position_list')
    if (object) {
      for (let i = 0; i < object.length; i++) {
        if (object[i]._id === id) {
          return {
            label: `${_.get(object[i], 'position_code')} - ${_.get(object[i], 'name')}`,
            position_code: _.get(object[i], '_id'),
          }
        }
      }
    }
    return ''
  }
  checkLevel(id) {
    const object = _.get(this.props, 'emp_level_list')
    if (object) {
      for (let i = 0; i < object.length; i++) {
        if (object[i]._id === id) {
          return {
            label: `${_.get(object[i], 'level_code')} - ${_.get(object[i], 'name')}`,
            level_code: _.get(object[i], '_id'),
          }
        }
      }
    }
    return ''
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => { this.toggle('1') } }
            >
              Confidential Information
            </NavLink>
          </NavItem>
          {
            !_.get(this.props, 'create') &&
            <NavItem>
              <NavLink
                className={ classnames({ active: this.state.activeTab === '2' }) }
                onClick={ () => { this.toggle('2') } }
              >
              Confidential History
              </NavLink>
            </NavItem>
          }
          <Image
            src={ url }
            onClick={ _.get(this.props, 'confirm') === 'confidentialForm' ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form>
                  <FormGroup>
                    <Container>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Start Date</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputFieldDate
                            autoComplete='off'
                            type="date"
                            name="start_date"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            value={ _.get(this.props, 'start_date') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }>
                            <Label >Employee Name</Label>
                          </Col>
                          <Col sm={ 9 }>
                            <SelectInputField
                              styles={ customStyles }
                              name='user_id'
                              isDisabled={ _.get(this.props, 'create') === undefined }
                              value={ this.checkEmployee(this.props.user_id) }
                              options={ this.createEmployeeList() }
                              onChange={ this.props.handleEmployee }
                            />
                          </Col>
                        </Row>
                      }
                      {
                        <div>
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }>
                              <Label >Company</Label>
                            </Col>
                            <Col sm={ 9 }>
                              <InputField
                                name="company_name"
                                disabled
                                value={ _.get(this.props, 'company_name') }
                              />
                            </Col>
                          </Row>
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }>
                              <Label >LOB</Label>
                            </Col>
                            <Col sm={ 9 }>
                              <InputField
                                name="lob_name"
                                disabled
                                value={ _.get(this.props, 'lob_name') }
                              />
                            </Col>
                          </Row>
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }>
                              <Label >Position</Label>
                            </Col>
                            <Col sm={ 9 }>
                              <InputField
                                name="position_name"
                                disabled
                                value={ _.get(this.props, 'position_name') }
                              />
                            </Col>
                          </Row>
                          <Row style={ { marginTop: 10 } }>
                            <Col sm={ 3 }>
                              <Label >Pay Grade Name</Label>
                            </Col>
                            <Col sm={ 9 }>
                              <SelectInputField
                                styles={ customStyles }
                                name='emp_level'
                                isDisabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.checkLevel(this.props.emp_level_id) }
                                options={ this.createLevelList() }
                                onChange={ this.props.handleLevel }
                              />
                            </Col>
                          </Row>
                        </div>
                      }
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Salary</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <NumberField
                            name="salary"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Salary"
                            value={ _.get(this.props, 'salary') }
                            allowEmptyFormatting={ true }
                            thousandSeparator={ true }
                            decimalScale={ 2 }
                            fixedDecimalScale={ true }
                            onChange={ (e) => {
                              e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                              this.props.handleInput(e)
                            }
                            }
                            // onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Other income</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <NumberField
                            name="other_income"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Other Income"
                            value={ _.get(this.props, 'other_income') }
                            allowEmptyFormatting={ true }
                            thousandSeparator={ true }
                            decimalScale={ 2 }
                            fixedDecimalScale={ true }
                            onChange={ (e) => {
                              e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                              this.props.handleInput(e)
                            }
                            }
                            // onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        _.get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            {
                              <CustomInputField
                                type="select"
                                id="is_active"
                                name="is_active"
                                disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.props.is_active }
                                onChange={ this.props.handleInput }
                              >
                                {
                                  status.map((s, key) => <option key={ key } value={ s.value }>{ s.label }</option>)
                                }
                              </CustomInputField>
                            }
                          </Col>
                        </Row>
                      }
                    </Container>
                  </FormGroup>
                  <Right>
                    { _.get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
        {
          !_.get(this.props, 'create') &&
          <TabContent activeTab={ this.state.activeTab } >
            <TabPane tabId="2">
              <RowTab>
                <Col>
                  <RowDetail noGutters>
                    <Col>
                      <Row noGutters>
                        Emp ID:&nbsp;
                        <Row noGutters>
                          {this.props.emp_code}
                        </Row>
                      </Row>

                    </Col>
                    <Col>
                      <Row noGutters>
                        Name:&nbsp;
                        <Row noGutters>
                          {this.props.name}
                        </Row>
                      </Row>
                    </Col>
                  </RowDetail>
                  <Rowtable noGutters>
                    <Col>
                      <TableConfidentialHistory
                        emp_code={ this.props.emp_code }
                        confidential_group={ this.props.confidential_group }
                        handleClickShowInformation={ this.handleClickShowInformation }
                      />
                    </Col>
                  </Rowtable>
                  {
                    _.get(this.state, 'showInformation') &&
                    <RowInfo noGutters>
                      <Col>
                        <HeadText>
                          <Word>History Information</Word>
                        </HeadText>
                        <Row>
                          <Col>Start Date:</Col>
                          <Col>
                            <InputFieldDate
                              disabled
                              value={
                                _.get(this.state, 'information.start_date') ?
                                  moment(_.get(this.state, 'information.start_date')).format('DD/MM/YYYY') : ''
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>Company:</Col>
                          <Col>
                            <InputField
                              disabled
                              value={ _.get(this.state, 'information.company') }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>LOB:</Col>
                          <Col>
                            <InputField
                              disabled
                              value={ _.get(this.state, 'information.lob') }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>Position:</Col>
                          <Col>
                            <InputField
                              disabled
                              value={ _.get(this.state, 'information.position') }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>Salary:</Col>
                          <Col>
                            <NumberField
                              disabled
                              thousandSeparator={ true }
                              decimalScale={ 2 }
                              fixedDecimalScale={ true }
                              value={ _.get(this.state, 'information.salary') }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>Other Income:</Col>
                          <Col>
                            <NumberField
                              disabled
                              thousandSeparator={ true }
                              decimalScale={ 2 }
                              fixedDecimalScale={ true }
                              value={ _.get(this.state, 'information.other_income') }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </RowInfo>
                  }
                </Col>
              </RowTab>
            </TabPane>
          </TabContent>
        }
      </Background>
    )
  }
}

ConfidentialForm.propTypes = {
  handleInput: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}

export default ConfidentialForm

const NumberField = styled(NumberFormat)`
    font-family: 'Gotham' !important;
    text-align: right;
    width : 100%;
    heigth: 100%;
    font-size: 14px ;
    padding-right: 2%;
    border-radius: 5px;
    border: 1px solid #CCCCCC;
    background-color: ${props => {
    if (props.disabled) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`
const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`
const HeadText = styled(Row)`
  font-family: 'Gotham-Bold' !important;
  font-size: '18px' !important;
`
const RowTab = styled(Row)`
  overflow-y: auto;
  max-height: calc(100vh - 100px);
`
const RowDetail = styled(Row)`
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 3% ;
  padding-bottom: 0% ;
`
const RowInfo = styled(Row)`
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 0% ;
  padding-bottom: 3% ;
  max-height: 300px ;
  overflow-y: scroll;
`
const Rowtable = styled(Row)`
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 3%;
  max-height: 240px ;
`
const Background = styled.div`
  background-color: white;
  padding-bottom: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }
`
const SelectInputField = styled(Select)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const Word = styled.p`
  font-size:16px;
  font-family:'Gotham-Bold' !important;
  padding-left: 2%;
  width: 100%;
`
const Image = styled.img`
width: 20px;
height: 20px;
position: absolute;
right: 10px;
`
const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const customStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? '#007bff' : "#FFFFFF",
    color: state.isFocused ? 'white' : 'black',
  }),
  menu: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#e9ecef' : "#FFFFFF",
    padding: 0,
  }),
  control: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#e9ecef' : "#FFFFFF",
  }),
}




// WEBPACK FOOTER //
// ./src/components/confidential/index.js